import { render } from "./App.vue?vue&type=template&id=87d444ea"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=87d444ea&lang=css"

import exportComponent from "/home/runner/work/static-apps/static-apps/src/jameda-desktop-opener/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__